import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { Suspense } from 'react';
import { Image } from '@/components/client';
import { BenefitsBanner } from './BenefitsBanner';
interface MainInfoSectionProps {
  title: string;
  summary: string;
  description: string;
  institutionId: number;
  backgroundVideoImageUrl: string;
  pcBackgroundVideoImageUrl?: string;
  logoUrl: string;
  //* 카뱅 시안은 로고·지역명을 히어로 위에 얹고 이미지 아래 기관 정보 블록을 두지 않는다.
  isKakaobank: boolean;
  hasGoodsEventBanner: boolean;
}
const DUMMY_HERO_IMAGE_URL = 'https://cdn.welfarehello.com/static/institution-hero-common.png';
export const MainInfoSection = t0 => {
  const $ = _c(52);
  const {
    title,
    summary,
    description,
    institutionId,
    backgroundVideoImageUrl,
    pcBackgroundVideoImageUrl,
    logoUrl,
    isKakaobank,
    hasGoodsEventBanner
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <h1 className="sr-only">{title}</h1>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = cn("absolute z-[1] size-full", "mobile-tablet:hidden");
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== logoUrl || $[4] !== title) {
    t3 = <Image src={logoUrl} alt={title} width={48} height={48} className="rounded-pill" />;
    $[3] = logoUrl;
    $[4] = title;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== title) {
    t4 = <p aria-hidden={true} className="font-800 text-Gray-white typo-h4">{title}</p>;
    $[6] = title;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <div className="shrink-0 basis-[360px] flex-col gap-20 flex-center">{t3}{t4}</div>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="h-100 border-l-1 border-Gray-white/60" />;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== summary) {
    t7 = <p className="whitespace-pre-line break-keep text-left font-700 text-Gray-white typo-h5">{summary}</p>;
    $[12] = summary;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== description) {
    t8 = <div className="whitespace-pre-line break-keep text-left font-500 text-Gray-white typo-body2 [&_p]:!text-Gray-white [&_span]:!text-Gray-white" dangerouslySetInnerHTML={{
      __html: description
    }} />;
    $[14] = description;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t7 || $[17] !== t8) {
    t9 = <div className="flex grow-[3] flex-col gap-16 pl-120">{t7}{t8}</div>;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t5 || $[20] !== t9) {
    t10 = <div className={t2}><div className="my-auto size-full gap-40 flex-center content-container">{t5}{t6}{t9}</div></div>;
    $[19] = t5;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  const t11 = backgroundVideoImageUrl ?? DUMMY_HERO_IMAGE_URL;
  let t12;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = cn("aspect-[500/346] w-full object-cover", "hidden mobile-tablet:block");
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t11) {
    t13 = <Image src={t11} alt={"\uC9C0\uC790\uCCB4 \uD788\uC5B4\uB85C \uC774\uBBF8\uC9C0"} width={850} height={588} preload={true} className={t12} />;
    $[23] = t11;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  const t14 = pcBackgroundVideoImageUrl ?? DUMMY_HERO_IMAGE_URL;
  let t15;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = cn("aspect-[1920/456] w-full object-cover", "mobile-tablet:hidden");
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== t14) {
    t16 = <Image src={t14} alt={"\uC9C0\uC790\uCCB4 \uD788\uC5B4\uB85C \uC774\uBBF8\uC9C0"} width={1920} height={456} preload={true} className={t15} />;
    $[26] = t14;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <div className={cn("absolute inset-0 bg-Gray-black/30 bg-gradient-to-b from-transparent from-50% to-Gray-black/60", "mobile-tablet:hidden")} />;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== isKakaobank || $[30] !== logoUrl || $[31] !== title) {
    t18 = isKakaobank ? <div className={cn("absolute inset-0 hidden items-end gap-8 bg-gradient-to-b from-transparent from-50% to-Gray-black/50 px-32 pb-32", "mobile-tablet:flex")}><Image src={logoUrl} alt={title} width={56} height={56} className="size-56 shrink-0 rounded-pill border-1 border-Gray-black/5 object-cover shadow-[4px_0_7px_0_rgba(0,0,0,0.3)]" /><p aria-hidden={true} className="break-keep pb-8 font-700 text-Gray-white typo-h5">{title}</p></div> : <Image src={logoUrl} alt={title} width={72} height={72} className={cn("absolute bottom-0 left-20 hidden translate-y-1/2 rounded-pill object-cover shadow-lg", "mobile-tablet:block")} />;
    $[29] = isKakaobank;
    $[30] = logoUrl;
    $[31] = title;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] !== t10 || $[34] !== t13 || $[35] !== t16 || $[36] !== t18) {
    t19 = <div className="relative">{t10}{t13}{t16}{t17}{t18}</div>;
    $[33] = t10;
    $[34] = t13;
    $[35] = t16;
    $[36] = t18;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== description || $[39] !== isKakaobank || $[40] !== summary || $[41] !== title) {
    t20 = isKakaobank ? null : <div className={cn("hidden px-20 pt-48", "mobile-tablet:block")}><p aria-hidden={true} className="mb-4 font-700 text-Gray-black typo-h6">{title}</p><p className="mb-16 whitespace-pre-line font-500 text-Gray-700 typo-body3">{summary}</p><p className="text-Gray-600 typo-body3 [&_p]:!text-Gray-600 [&_p]:!typo-body4 [&_span]:!text-Gray-600 [&_span]:!typo-body4" dangerouslySetInnerHTML={{
        __html: description
      }} /></div>;
    $[38] = description;
    $[39] = isKakaobank;
    $[40] = summary;
    $[41] = title;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== hasGoodsEventBanner || $[44] !== institutionId || $[45] !== isKakaobank) {
    t21 = isKakaobank ? null : <div className={cn("mt-32 px-40 content-container", "mobile-tablet:px-20")}><Suspense fallback={<div className={cn("aspect-[1200/180] w-full rounded-medium bg-Gray-50", "mobile-tablet:aspect-[335/124]")} />}><BenefitsBanner institutionId={institutionId} hasGoodsEventBanner={hasGoodsEventBanner} /></Suspense></div>;
    $[43] = hasGoodsEventBanner;
    $[44] = institutionId;
    $[45] = isKakaobank;
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  let t22;
  if ($[47] !== t1 || $[48] !== t19 || $[49] !== t20 || $[50] !== t21) {
    t22 = <section>{t1}{t19}{t20}{t21}</section>;
    $[47] = t1;
    $[48] = t19;
    $[49] = t20;
    $[50] = t21;
    $[51] = t22;
  } else {
    t22 = $[51];
  }
  return t22;
};